import { success } from '../../../../../utils/promise-middleware-utils';
import UpdateUnreadChatroomsSubReducer, { UpdateUnreadChatroomsFromPayloadSubReducer } from './subreducer.update-unread-chatrooms';
import MarkChatroomReadSubReducer from './subreducer.mark-chatroom-read';
import MarkChatroomUnreadSubReducer from './subreducer.mark-chatroom-unread';
import actionTypes from '../../types';
var GlobalUnreadsCountReducer = /** @class */ (function () {
    function GlobalUnreadsCountReducer(config) {
        var _a;
        this.subReducers = (_a = {},
            _a[actionTypes.UPDATE_UNREAD_CHATROOMS] = new UpdateUnreadChatroomsSubReducer(config),
            _a[actionTypes.MARK_CHATROOM_READ] = new MarkChatroomReadSubReducer(config),
            _a[actionTypes.MARK_CHATROOM_UNREAD] = new MarkChatroomUnreadSubReducer(config),
            _a[success(actionTypes.FETCH_UNREAD_CHATROOM_IDS)] = new UpdateUnreadChatroomsFromPayloadSubReducer(config),
            _a);
    }
    GlobalUnreadsCountReducer.prototype.reduce = function (state, action) {
        if (state === void 0) { state = initialState; }
        var subReducer = this.subReducers[action.type];
        if (subReducer) {
            return subReducer.reduce(state, action);
        }
        return state;
    };
    return GlobalUnreadsCountReducer;
}());
var initialState = {
    chatroomIds: undefined,
    chatroomsCount: 0,
};
export default (function (config) {
    var reducer = new GlobalUnreadsCountReducer(config);
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        return reducer.reduce(state, action);
    };
});
